import Vue from 'vue'
import leadsAPI from "@/api/leads";
import productsAPI from "@/api/products";
import accountAttach from "@/store/SalesLeads/AccountAttach";
import accountSearch from "@/store/SalesLeads/AccountSearch";

const state = () => ({
  currentLeadLoading: false,
  currentLead: {},
  currentLeadProducts: {},
  currentLeadProductsLoading: true,
  currentLeadLinkedProducts: {},
  currentLeadLinkedProductsLoading: false,
  currentLeadTariffs: {},
  currentLeadOptions: {},

  leadIndustries: [],
  fetchLeadIndustriesLoading: false,
  fetchLeadIndustriesError: false,
  fetchLeadIndustriesErrorResponse: null,
  
  currentLeadAuditLoading: false,
  currentLeadAudit: {
    logs: [],
    config: {
      paginationCount: 0,
      paginationLimit: 10,
      paginationPage: 1,
    }
  },
  
  currentLeadQuoteLoading: false,
  currentLeadSendQuoteLoading: false,
  currentLeadQuote: {},
  dealStageItems: [],
  dealStageItemsLoading: false,
  createBillingOpen: false,
  createBillingLoading: false,
  sendDDMandateOpen: false,
  sendDDMandateLoading: false,
});

const mutations = {
  SET_LEAD_LOADING(state,payload){ state.currentLeadLoading = payload; },
  UPDATE_CURRENTLEAD(state,payload){ state.currentLead[payload.key] = payload.data; },
  SET_CURRENTLEAD(state,payload){ state.currentLead = payload; state.currentLead.partner_object = {}; },
  SET_PARTNER(state,payload){ state.currentLead.partner_object = payload; },
  SET_LEAD_PRODUCTS(state,payload){
    state.currentLeadProducts = payload;
    state.currentLeadProductsLoading = false;
  },
  SET_LEAD_PRODUCTS_LOADING(state,payload){ state.currentLeadProductsLoading = payload; },
  SET_LEAD_LINKED_PRODUCTS(state,payload){
    state.currentLeadLinkedProducts = payload;
    state.currentLeadLinkedProductsLoading = false;
  },
  SET_LEAD_LINKED_PRODUCTS_LOADING(state,payload){ state.currentLeadLinkedProductsLoading = payload; },
  SET_LEAD_TARIFFS(state,payload){ state.currentLeadTariffs = payload; },
  SET_LEAD_OPTIONS(state,payload){ state.currentLeadOptions = payload; },
  
  SET_CURRENTLEAD_AUDIT_LOADING(state,payload) { 
    state.currentLeadAuditLoading = payload; 
  },
  SET_CURRENTLEAD_AUDIT(state,payload){
    state.currentLeadAudit.config.paginationCount = parseInt(payload.headers['pagination-count']);
    state.currentLeadAudit.logs = payload.data;
    state.currentLeadAuditLoading = false;
  },
  SET_CURRENTLEAD_AUDIT_PAGINATION(state,options){
    state.currentLeadAudit.config.paginationLimit = options.itemsPerPage;
    state.currentLeadAudit.config.paginationPage = options.page;
  },
  RESET_CURRENTLEAD_AUDIT(state) {
    state.currentLeadAudit.logs = [];
    state.currentLeadAudit.config.paginationCount = 0;
    state.currentLeadAudit.config.paginationLimit = 10;
    state.currentLeadAudit.config.paginationPage = 1;
  },

  SET_QUOTE_LOADING(state,payload){ state.currentLeadQuoteLoading = payload; },
  SET_SEND_QUOTE_LOADING(state,payload){ state.currentLeadSendQuoteLoading = payload; },
  SET_CURRENTLEAD_QUOTE(state,payload){ state.currentLeadQuote = payload; },
  SET_DEAL_STAGE_ITEMS(state,payload){ state.dealStageItems = payload; },
  SET_DEAL_STAGE_ITEMS_LOADING(state,payload){ state.dealStageItemsLoading = payload; },
  SET_DEAL_STAGE_SELECTED(state,payload){ state.currentLead.hubspot_deal_stage_name = payload; },
  SET_CREATE_BILLING_OPEN(state,payload){ state.createBillingOpen = payload; },
  SET_CREATE_BILLING_LOADING(state,payload){ state.createBillingLoading = payload; },
  setSendDDMandateOpen(state, payload) { state.sendDDMandateOpen = payload; },
  setSendDDMandateLoading(state, payload) { state.sendDDMandateLoading = payload; },

  FETCH_LEAD_INDUSTRIES_BEGIN(state) {
    state.fetchLeadIndustriesLoading = true;
    state.fetchLeadIndustriesError = false;
    state.fetchLeadIndustriesErrorResponse = null;
  },
  FETCH_LEAD_INDUSTRIES_SUCCESS(state, payload) {
    state.fetchLeadIndustriesLoading = false;
    state.leadIndustries = payload;
  },
  FETCH_LEAD_INDUSTRIES_ERROR(state, err) {
    state.fetchLeadIndustriesLoading = false;
    state.fetchLeadIndustriesError = true;
    state.fetchLeadIndustriesErrorResponse = err;
  }
};

const actions = {
  async sendDDMandate({commit,dispatch},id){
    commit('setSendDDMandateLoading',true);
    try{
      const res = await leadsAPI.sendDDMandate(id);
      if(res.status===200){
        dispatch("alerts/setAlert", {type: "success",message: 'DD Mandate sent successfully!'}, { root: true });
        commit('setSendDDMandateOpen',false);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
      commit('setSendDDMandateLoading',false);
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
      commit('setSendDDMandateLoading',false);
    }
  },
  async getLeadByID({commit,dispatch,state},{id}){
    commit('SET_LEAD_LOADING',true);
    try{
      const res = await leadsAPI.getLeadByID(id);
      if(res.status===200){
        commit('SET_CURRENTLEAD',res.data);
        await dispatch("leads/getPartnerByID", state.currentLead.partner_id, { root: true });
        commit('SET_LEAD_LOADING',false);
        return res.data;
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  async getQuoteByLeadID({commit,dispatch},id){
    commit('SET_QUOTE_LOADING',true);
    try{
      const res = await leadsAPI.getLeadQuoteByID(id);
      if(res.status===200){
        commit('SET_CURRENTLEAD_QUOTE',res.data);
        commit('SET_QUOTE_LOADING',false);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  async sendLeadQuoteByID({commit,dispatch},id){
    commit('SET_SEND_QUOTE_LOADING',true);
    try{
      const res = await leadsAPI.sendLeadQuoteByID(id);
      if(res.status===200){
        dispatch("alerts/setAlert", {type: "success",message: "Quote sent successfully!"}, { root: true });
        commit('SET_SEND_QUOTE_LOADING',false);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  async getPartnerByID({commit,dispatch},id){
    if(id!==null){
      try{
        const res = await leadsAPI.getPartnerByID(id);
        if(res.status===200){
          commit('SET_PARTNER',res.data);
        }else{
          dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        }
      }catch(err){
        dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
      }
    }
  },
  async getLeadLinkedProductByID({commit,dispatch},id){
    commit('SET_LEAD_LINKED_PRODUCTS_LOADING',true);
    try{
      const res = await productsAPI.getProductById(id);
      if(res.status===200){
        commit('SET_LEAD_LINKED_PRODUCTS',res.data);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  async getLeadProductByID({commit,dispatch},{id}){
    commit('SET_LEAD_PRODUCTS_LOADING',true);
    try{
      const res = await productsAPI.getProductById(id);
      if(res.status===200){
        commit('SET_LEAD_PRODUCTS',res.data);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  async getLeadProductsByID({commit,dispatch},{id}){
    commit('SET_LEAD_PRODUCTS_LOADING',true);
    try{
      const res = await productsAPI.loadProducts(id);
      if(res.status===200){
        commit('SET_LEAD_PRODUCTS',res.data);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  async getLeadTariffs({commit,dispatch}){
    try{
      const res = await leadsAPI.getAllTariffs();
      if(res.status===200){
        commit('SET_LEAD_TARIFFS',res.data);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  async getCurrentLeadAudit({state,commit,dispatch},id){
    commit('SET_CURRENTLEAD_AUDIT_LOADING',true);
    try{
      let data = await leadsAPI.getLeadAuditByID(id,state.currentLeadAudit.config);
      if(data.status===200){
        commit('SET_CURRENTLEAD_AUDIT',data);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: data.response.data.message}, { root: true });
      }
    }catch(error){
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
    }
  },
  async updateCurrentLeadAuditPagination({commit,dispatch},{id,options}){
    commit('SET_CURRENTLEAD_AUDIT_PAGINATION',options);
    dispatch('getCurrentLeadAudit',id);
  },
  async getLeadOptions({commit,dispatch}){
    let data = {
      'current_providers_voip': [
        {id:'BT',value:'BT'},{id:'Vodafone',value:'Vodafone'},{id:'TTB',value:'TTB'},{id:'Virgin',value:'Virgin'},{id:'Daisy',value:'Daisy'},{id:'XLN / Onebill',value:'XLN / Onebill'},{id:'Kinex / ClearlyB',value:'Kinex / ClearlyB'},{id:'V4 Telecom',value:'V4 Telecom'},{id:'Vonage',value:'Vonage'},{id:'8x8',value:'8x8'},{id:'Ring Central',value:'Ring Central'},{id:'4Com / HiHi',value:'4Com / HiHi'},{id:'VoIPfone',value:'VoIPfone'},{id:'Zoom Phone',value:'Zoom Phone'},{id:'Lily Comms',value:'Lily Comms'},{id:'Berry',value:'Berry'},{id:'Airlandline',value:'Airlandline'},{id:'Dialpad',value:'Dialpad'}
      ],
      'current_providers_telco': [{id:'BT Business',value:'BT Business'},{id:'Talk Tak Business',value:'Talk Tak Business'},{id:'XLN',value:'XLN'},{id:'Fuel Broadband',value:'Fuel Broadband'},{id:'Chess',value:'Chess'},{id:'True Telecom',value:'True Telecom'},{id:'Plus Net',value:'Plus Net'},{id:'Other',value:'Other'},{id:'New Line',value:'New Line'},{id:'Restart',value:'Restart'},{id:'Working Line take over',value:'Working Line take over'},{id:'Unicom',value:'Unicom'},{id:'Virgin',value:'Virgin'},{id:'Onebill',value:'Onebill'},{id:'Daisy',value:'Daisy'},{id:'True Telecoms',value:'True Telecoms'},{id:'Titan',value:'Titan'}],
      'deal_stages': [
        {id: 'Stage 1', value: 'Stage 1'},
        {id: 'Stage 2', value: 'Stage 2'},
        {id: 'Stage 3', value: 'Stage 3'},
      ],
      'lead_source': [
        {id:'adwords',value:'Adwords'},{id:'Sales',value:'Sales'},{id:'Index',value:'Index'},{id:'Index Premium',value:'Index Premium'},{id:'Index Voip',value:'Index Voip'},{id:'Index Websites',value:'Index Websites'},{id:'Index Telecoms',value:'Index Telecoms'},{id:'SA',value:'SA'},{id:'Inbound',value:'Inbound'},{id:'Inbound Websites',value:'Inbound Websites'},{id:'Inbound Voip',value:'Inbound Voip'},{id:'TFC',value:'TFC'},{id:'India',value:'India'},{id:'Affiliate',value:'Affiliate'},{id:'uSwitch',value:'uSwitch'},{id:'BroadbandChoices',value:'BroadbandChoices'},{id:'BroadbandGenie',value:'BroadbandGenie'},{id:'MoneySupermarke',value:'MoneySupermarke'},{id:'Dealer',value:'Dealer'},{id:'Partner',value:'Partner'},{id:'referral',value:'referral'},{id:'COP',value:'COP'},{id:'COT',value:'COT'},{id:'Cross-selling',value:'Cross-selling'},{id:'Inbound referral',value:'Inbound referral'},{id:'InTouch',value:'InTouch'},{id:'Google',value:'Google'},{id:'Google SEM',value:'Google SEM'},{id:'Bing',value:'Bing'},{id:'Facebook',value:'Facebook'},{id:'Homepage',value:'Homepage'},{id:'TEYA',value:'TEYA'},{id:'Topcashback',value:'Topcashback'},{id:'Index Chase',value:'Index Chase'},{id:'Inbound Chase',value:'Inbound Chase'},{id:'Outbound referral',value:'Outbound referral'},{id:'Trustpilot',value:'Trustpilot'},{id:'Switch&Save',value:'Switch&Save'},{id:'Google Voip',value:'Google Voip'},{id:'Compare The Market',value:'Compare The Market'},{id:'GoCompare',value:'GoCompare'},{id:'Index Telecoms Premium',value:'Index Telecoms Premium'},{id:'Index Voip 5-9',value:'Index Voip 5-9'},{id:'Index Voip 3-4',value:'Index Voip 3-4'},{id:'Index Telco',value:'Index Telco'},{id:'GETVoIP',value:'GETVoIP'},{id:'Email',value:'Email'},{id:'Satya',value:'Satya'},{id:'Referral',value:'Referral'},{id:'E-location',value:'E-location'},{id:'Lead Advisory',value:'Lead Advisory'},{id:'Top5Voip',value:'Top5Voip'},{id:'Top5VoIP',value:'Top5VoIP'},{id:'Ropto',value:'Ropto'},{id:'Tech Radar',value:'Tech Radar'},{id:'AllGroove',value:'AllGroove'},{id:'TFLI',value:'TFLI'},{id:'businesscostsaver.co.uk',value:'businesscostsaver.co.uk'},{id:'Bark',value:'Bark'},{id:'LegalZoom',value:'LegalZoom'},{id:'ElevateOM_WEB', value:'ElevateOM_WEB'},{id:'New Line', value:'New Line'},{id:'GoToData', value:'GoToData'},{id:'BusinessComparison', value:'BusinessComparison'},
      ],
      'channels': [
        {id:'Cold Calling',value:'Cold Calling'},
        {id:'Inbound',value:'Inbound'},
        {id:'Index',value:'Index'},
        {id:'Loyalty', value:'Loyalty'},
        {id:'Outbound',value:'Outbound'},
        {id:'Partners',value:'Partners'},
        {id:'Self Sign Up',value:'Self Sign Up'},
        {id:'Chase',value:'Chase'},
        {id:'Self Sign Up TE',value:'Self Sign Up TE'},
        {id:'Verification',value:'Verification'},
        {id:'Legalzoom',value:'Legalzoom'},
        {id:'FTC',value:'FTC'},
      ],
      'channels_for_new': [
        {id:'Cold Calling',value:'Cold Calling'},
        {id:'Inbound',value:'Inbound'},
        {id:'Index',value:'Index'},
        {id:'Loyalty', value:'Loyalty'},
        {id:'Outbound',value:'Outbound'},
        {id:'Partners',value:'Partners'},
        {id:'Chase',value:'Chase'},
        {id:'Self Sign Up TE',value:'Self Sign Up TE'},
        {id:'Verification',value:'Verification'},
        {id:'Legalzoom',value:'Legalzoom'},
        {id:'FTC',value:'FTC'},
      ],
    };
    try{
      const res = await leadsAPI.getLeadStaticData({object_kind: 'Lead', field: 'pain_points'});
      if(res.status===200){
        data.pain_point = res.data;
        await commit('SET_LEAD_OPTIONS',data);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },

  async fetchLeadIndustries({commit, dispatch}) {
    commit('FETCH_LEAD_INDUSTRIES_BEGIN');
    try {
      const response = await leadsAPI.getLeadStaticData({ object_kind: 'Lead', field: 'industry', limit: 200, sort: 'value' });
      commit('FETCH_LEAD_INDUSTRIES_SUCCESS', response.data);
    } catch(err) {
      commit('FETCH_LEAD_INDUSTRIES_ERROR', err.response.data.message)
      dispatch('alerts/setAlert', {type: 'error', message: err.response.data.message}, { root: true });
    }
  },

  async getDealStagesById({commit,dispatch},id){
    commit('SET_DEAL_STAGE_ITEMS_LOADING',true);
    let items = await dispatch("localCache/LSC_getItem", `dealStages_${id}`, { root: true });
    if(items!==null){
      commit('SET_DEAL_STAGE_ITEMS',items);
      commit('SET_DEAL_STAGE_ITEMS_LOADING',false);
    }else{
      try{
        const res = await leadsAPI.getDealStagesById(id);
        if(res.status===200){
          commit('SET_DEAL_STAGE_ITEMS',res.data.stages);
          dispatch("localCache/LSC_setItem", {data:{key:`dealStages_${id}`,value:res.data.stages}}, { root: true });
        }else{
          dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        }
        commit('SET_DEAL_STAGE_ITEMS_LOADING',false);
      }catch(err){
        dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
      }
    }
  },
  async createBillingAccount({commit,dispatch},{id,data}){
    commit('SET_CREATE_BILLING_LOADING',true);
    try{
      const res = await leadsAPI.createBillingAccount(id,data);
      if(res.status===200){
        await dispatch("leads/getLeadByID", {id}, { root: true });
        dispatch("alerts/setAlert", {type: "success",message: 'Billing account created successfully!'}, { root: true });
        commit('SET_CREATE_BILLING_OPEN',false);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
      commit('SET_CREATE_BILLING_LOADING',false);
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
      commit('SET_CREATE_BILLING_LOADING',false);
    }
  },
  async updateLead({commit,dispatch},{id,data,success}){
    try{
      const res = await leadsAPI.updateLead(id,data);
      if(res.status===200){
        await dispatch("leads/getLeadByID", {id}, { root: true });
        dispatch("alerts/setAlert", {type: "success",message: success}, { root: true });
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        throw res;
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
      throw err;
    }
  },
  async updateLeadSource({dispatch},{sentData}){
    let patchData = {
      id: sentData.id,      
      data: sentData.data,
      success: 'Lead Source updated successfully'
    };
    await dispatch("leads/updateLead", patchData, { root: true });
  },
  async updateCurrentProvider({ dispatch }, { id, data }) {
    let patchData = {
      id,
      data,
      success: 'Current Provider updated successfully'
    };
    await dispatch("leads/updateLead", patchData, { root: true });
  },
  async updateLeadCustomer({dispatch},{sentData}){
    let patchData = {
      id: sentData.id,      
      data: {
        contact: {
          name: sentData.data.contact.name,
          phone_number: sentData.data.contact.phone_number,
          mobile_number: sentData.data.contact.mobile_number,
          email_address: sentData.data.contact.email_address,
        },
        business_name: sentData.data.business_name,
        address_post_code: sentData.data.address_post_code,
        industry: sentData.data.industry,
        industry_description: sentData.data.industry_description,
        current_provider: sentData.data.current_provider,
      },
      success: 'Customer Details updated successfully'
    };
    await dispatch("leads/updateLead", patchData, { root: true });
  },
  async updateLeadSalesPerson({ dispatch }, { id, data }) {
    const patchData = { 
      id, 
      data: { sales_person: data.sales_person },
      success: "Sales Person updated successfully"};
    await dispatch("leads/updateLead", patchData, { root: true });
  },
  async updatePainPoints({dispatch},{sentData}){
    let patchData = {
      id: sentData.id,      
      data: { 
        pain_points: sentData.data.pain_points,
        pain_points_notes: sentData.data.pain_points_notes,
        current_setup: sentData.data.current_setup
      },
      success: 'Pain Points updated successfully'
    };
    await dispatch("leads/updateLead", patchData, { root: true });
  },
  async updateDealStage({commit,dispatch},{sentData}){
    let patchData = {
      id: sentData.id,      
      data: { hubspot_deal_stage_id: sentData.data.deal_stage },
      success: 'Deal Stage updated successfully'
    };
    await dispatch("leads/updateLead", patchData, { root: true });
    commit('SET_DEAL_STAGE_SELECTED',sentData.data.name);
  },
  async sendSms({dispatch},{id,data}){
    try{
      const res = await leadsAPI.sendSmsApi(id,data);
      if(res.status===200){
        dispatch("alerts/setAlert", {type: "success",message: 'SMS sent successfully!'}, { root: true });
        return true;
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        return false;
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
      return false;
    }
  },
};

const getters = {
  getCurrentLead: state => state.currentLead,
  getCurrentLeadLoading: state => state.currentLeadLoading,
  getCurrentLeadAuditG: state => state.currentLeadAudit.logs,
  getLeadSources: state => {
    if(state.currentLeadOptions.lead_source!==undefined){
      return state.currentLeadOptions.lead_source.map((val)=>{
        return {text:val.value,value:val.id};
      })
    }
  },
  getLeadChannels: state => {
    if(state.currentLeadOptions.channels!==undefined){
      return state.currentLeadOptions.channels.map((val)=>{
        return {text:val.value,value:val.id};
      });
    }
  },
  getLeadChannelsForNew: state => {
    if(state.currentLeadOptions.channels_for_new!==undefined){
      return state.currentLeadOptions.channels_for_new.map((val)=>{
        return {text:val.value,value:val.id};
      });
    }
  },
  getLeadIndustries: state => {
    if(state.leadIndustries.length){
      return state.leadIndustries.map((val)=>{
        return {text: val.value, value: val.value};
      });
    }
    return [];
  },
  getLeadProviders: state => {
    if(state.currentLead.kind&&state.currentLeadOptions[`current_providers_${state.currentLead.kind.toLowerCase()}`]!==undefined){
      return state.currentLeadOptions[`current_providers_${state.currentLead.kind.toLowerCase()}`].map((val)=>{
        return {text:val.value,value:val.id};
      });
    }
  },
  getPainPoints: state => {
    if(state.currentLeadOptions.pain_point!==undefined){
      return state.currentLeadOptions.pain_point.map((val)=>{
        return val.value;
      });
    }
  },
  getDealStages: state => {
    if(state.dealStageItems!==undefined){
      return state.dealStageItems.map((val)=>{
        return {text:val.label,value:val.id};
      });
    }
  },
  getTariffByID: state => id => {
    if(Object.keys(state.currentLeadTariffs).length!==0){
      let ret = state.currentLeadTariffs.filter(tariff => tariff.id===id)[0];
      if(ret===undefined){ return {}; }
      return ret;
    }else{
      return {};
    }
  },
  getTopBarInfo: (state, getters, rootState) => {
    if(state.currentLeadLoading || rootState.globals.currentUserLoading) {
      return { business: 'Loading...' };
    } else if(Object.keys(state.currentLead).length) {
      return { business: `${state.currentLead.id } - ${ state.currentLead.business_name ? state.currentLead.business_name : 'New Customer' }`}
    } else {
      return { lead: '-', business: '-' };
    }
  },

  getCurrentLeadProducts: state => state.currentLeadProducts,
  currentLeadProductsLoading: state => state.currentLeadProductsLoading,

  getFetchLeadIndustriesLoading: state => state.fetchLeadIndustriesLoading,
  getFetchLeadIndustriesError: state => state.fetchLeadIndustriesError,
  getFetchLeadIndustriesErrorResponse: state => state.fetchLeadIndustriesErrorResponse
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    accountAttach,
    accountSearch,
  }
};
